import { DEEMA_DEADLINES, DEEMA_STORAGE_KEYS } from './constants'

function getTimestamp(key: string): number | null {
    const value = localStorage.getItem(key)
    return value ? parseInt(value, 10) : null
}

function isExpired(timestamp: number | null, maxMs: number) {
    if (!timestamp) return true

    return Date.now() - timestamp > maxMs
}

export const deemaTracker = {
    detectVisitFromURL: () => {
        if (typeof window === 'undefined') return

        const params = new URLSearchParams(window.location.search)
        const utmSource = params.get('utm_source')

        if (utmSource === 'deema') {
            localStorage.setItem(DEEMA_STORAGE_KEYS.activationTime, Date.now().toString())
        } else if (utmSource) {
            localStorage.removeItem(DEEMA_STORAGE_KEYS.activationTime)
            localStorage.removeItem(DEEMA_STORAGE_KEYS.cartAddedTime)
        }
    },

    setCart: () => {
        const activationTime = getTimestamp(DEEMA_STORAGE_KEYS.activationTime)
        const expired = isExpired(activationTime, DEEMA_DEADLINES.addToCartDeadline)

        if (expired) {
            localStorage.removeItem(DEEMA_STORAGE_KEYS.activationTime)
            return
        }

        localStorage.setItem(DEEMA_STORAGE_KEYS.cartAddedTime, Date.now().toString())
    },

    shouldSendPurchase: () => {
        const cartAddedTime = getTimestamp(DEEMA_STORAGE_KEYS.cartAddedTime)

        const expired = isExpired(cartAddedTime, DEEMA_DEADLINES.purchaseDeadline)

        if (expired) {
            localStorage.removeItem(DEEMA_STORAGE_KEYS.cartAddedTime)
            return false
        }

        return true
    },
}
